module.exports = __webpack_public_path__ + "assets/img/set.4267f8cf.png";